{
  "title": "مكونات الواجهة",
  "intro": "كل مكونات bPanel App في صفحة واحدة، بالاتجاهين. النصوص تتبع اللغة الحالية، ولكل عمود اتجاه ثابت.",
  "direction": {
    "label": "الاتجاه",
    "both": "الاتجاهان"
  },
  "dirLabel": {
    "rtl": "من اليمين إلى اليسار",
    "ltr": "من اليسار إلى اليمين"
  },
  "latency": {
    "normal": "تأخير عادي",
    "fast": "تأخير قليل",
    "slow": "تأخير كبير",
    "off": "بدون تأخير"
  },
  "sections": {
    "buttons": "الأزرار",
    "forms": "الحقول والنماذج",
    "surfaces": "الأسطح والعناوين",
    "status": "الحالات والتنبيهات",
    "data": "البيانات والاستهلاك",
    "table": "الجداول",
    "feedback": "الحالات الفارغة والأخطاء",
    "overlays": "النوافذ والقوائم",
    "flows": "الخطوات والأوامر",
    "plans": "الباقات والأسعار",
    "mock": "أدوات الوضع التجريبي"
  },
  "table": {
    "server": "السيرفر",
    "hostname": "اسم المضيف",
    "plan": "الباقة",
    "search": "ابحث بالاسم أو اسم المضيف"
  },
  "samples": {
    "addServer": "إضافة سيرفر",
    "email": "البريد الإلكتروني",
    "emailHint": "نرسل إليه الفواتير والتنبيهات.",
    "hostname": "اسم المضيف",
    "hostnameError": "اكتب اسم مضيف كامل، مثل server1.example.sa",
    "password": "كلمة المرور",
    "country": "الدولة",
    "server": "السيرفر",
    "message": "الرسالة",
    "messagePlaceholder": "اشرح المشكلة باختصار",
    "checkbox": "أرسل نسخة من كل فاتورة إلى فريق الفوترة",
    "checkboxHint": "تصلهم رسالة مع كل فاتورة جديدة.",
    "switch": "الشحن التلقائي لنقاط الذكاء الاصطناعي",
    "switchHint": "نضيف 100 نقطة عند انخفاض الرصيد.",
    "os": "نظام التشغيل",
    "osRecommended": "الخيار المقترح",
    "serverName": "Riyadh 1",
    "servers": "السيرفرات",
    "pageDescription": "server1.example.sa على باقة Pro، الدفع سنوي.",
    "panelTitle": "مفتاح التفعيل والتحديثات",
    "panelDescription": "كل ما يخص اشتراك هذا السيرفر.",
    "panelFooter": "آخر اتصال قبل دقيقتين.",
    "tabs": {
      "overview": "نظرة عامة",
      "overviewBody": "السيرفر متصل ويعمل، وكل المواقع تعمل كالمعتاد.",
      "updates": "التحديثات",
      "updatesBody": "الإصدار 1.5.0 متاح على القناة التجريبية."
    },
    "healthy": "يعمل",
    "attention": "يحتاج إلى متابعة",
    "failed": "فشل",
    "alerts": {
      "infoTitle": "الإصدار 1.4.2 متاح",
      "infoBody": "حدّث السيرفر لتحصل على آخر الإصلاحات.",
      "successTitle": "تم حفظ بيانات الفوترة",
      "warningTitle": "حسابات الاستضافة قريبة من الحد",
      "warningBody": "استخدمت 87 من 100 حساب على server2.example.sa.",
      "dangerTitle": "تعذّر تحصيل الدفعة",
      "dangerBody": "حدّث طريقة الدفع حتى تستمر إضافة الحسابات الجديدة."
    },
    "payNow": "ادفع الآن",
    "bannerTrial": "تبقّت 5 أيام على نهاية تجربتك المجانية. جهّز الدفع حتى تستمر سيرفراتك بدون انقطاع.",
    "stats": {
      "servers": "السيرفرات",
      "serversHint": "3 تعمل، 1 بانتظار الدفع",
      "renewal": "التجديد القادم",
      "credits": "نقاط الذكاء الاصطناعي المتبقية"
    },
    "chart": "استهلاك نقاط الذكاء الاصطناعي آخر 6 أشهر",
    "months": {
      "may": "مايو",
      "jun": "يونيو",
      "jul": "يوليو",
      "aug": "أغسطس",
      "sep": "سبتمبر",
      "oct": "أكتوبر"
    },
    "version": "الإصدار",
    "versionHint": "القناة المستقرة",
    "price": "السعر",
    "timeline": {
      "activated": "تم تفعيل السيرفر",
      "installed": "اكتمل التثبيت",
      "created": "تمت إضافة السيرفر"
    },
    "empty": {
      "title": "لم تضف أي سيرفر بعد",
      "body": "أضف سيرفرك الأول وثبّت bPanel عليه بأمر واحد."
    },
    "toasts": {
      "success": "نجاح",
      "info": "معلومة",
      "warning": "تنبيه",
      "error": "خطأ",
      "saved": "تم الحفظ",
      "copied": "تم نسخ اسم المضيف"
    },
    "openDialog": "نافذة",
    "openConfirm": "تأكيد الحذف",
    "openDrawer": "لوحة جانبية",
    "invite": "دعوة عضو",
    "tooltip": "تلميح قصير يشرح الزر",
    "hoverMe": "مرّر المؤشر هنا",
    "dialog": {
      "title": "تعديل اسم السيرفر",
      "body": "الاسم يظهر لك ولفريقك فقط."
    },
    "serverNameLabel": "اسم السيرفر",
    "confirm": {
      "title": "إلغاء اشتراك السيرفر؟",
      "body": "يستمر الاشتراك حتى نهاية الفترة المدفوعة، ثم تُقفل لوحة التحكم، ولا يُسترد مبلغ المدة المتبقية. المواقع والبريد وقواعد البيانات تستمر في العمل.",
      "action": "إلغاء الاشتراك"
    },
    "drawer": {
      "title": "تفاصيل السيرفر",
      "body": "ملخص سريع بدون مغادرة الصفحة."
    },
    "steps": {
      "plan": "اختر الباقة",
      "install": "ثبّت bPanel",
      "installHint": "شغّل الأوامر على السيرفر",
      "activate": "فعّل السيرفر"
    },
    "installationId": "معرّف التثبيت"
  },
  "mock": {
    "body": "اختبار الحالات الصعبة: عند انتهاء الجلسة تظهر نافذة تسجيل الدخول وتبقى في الصفحة نفسها.",
    "expire": "إنهاء الجلسة الآن",
    "signInFirst": "سجّل الدخول أولًا بحساب تجريبي."
  }
}
